<template>
    <b-card title="Asset Vendor">
        <b-card-body>
            <slot></slot>

            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [{ key: 'id', label: 'Actions' }, 'name', 'description'],
        }
    },

    mounted() {},

    methods: {
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `Are you sure you want to delete ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                console.log('result', result)

                if (result) {
                    this.$store
                        .dispatch('assets/deleteVendor', id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Your Item has been deleted.',
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete item!',
                                'error'
                            )
                        })
                }
            })
        },
    },

    computed: {
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
}
</script>
<style></style>
